import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import { whatsappTrackingWa } from 'Utils/trackingAttributes';

const cx = classNames.bind(styles);

export default class FixedButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverLogo: false,
      vibrateLogo: true,
      hoverTextArea: false,
      initialAnimationFinished: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ initialAnimationFinished: true, vibrateLogo: false });
    }, 8300);
    setTimeout(() => {
      this.setState({ vibrateLogo: true });
    }, 9000);
  }

  setHover = (area) => {
    if (this.state.initialAnimationFinished) {
      this.setState({ [area]: true });
    }
  };

  setNotHover = (area) => {
    this.setState({ [area]: false });
  };

  render() {
    const { settings } = this.props;
    const { hoverLogo, hoverTextArea, initialAnimationFinished, vibrateLogo } = this.state;

    const showAnimation = hoverLogo || hoverTextArea;

    const whatsappUrl =
      settings && settings.whatsappWidget && settings.whatsappWidget.isActive
        ? settings.whatsappWidget.whatsappUrl
        : undefined;

    if (!whatsappUrl) {
      return null;
    }

    return (
      <a
        className={cx('container')}
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Link zu WhatsApp öffnet in einem neuen Fenster oder Tab"
        {...whatsappTrackingWa('Fixed button')}
      >
        <span
          className={cx(
            'circle',
            showAnimation && 'circleOpen',
            !initialAnimationFinished && 'circleInitial'
          )}
        ></span>
        <span
          className={cx(
            'textArea',
            showAnimation && 'textAreaOpen',
            !initialAnimationFinished && 'textAreaInitial'
          )}
          onMouseEnter={() => this.setHover('hoverTextArea')}
          onMouseLeave={() => this.setNotHover('hoverTextArea')}
          {...whatsappTrackingWa('Fixed button')}
        >
          <span
            className={cx(
              'text',
              showAnimation && 'textOpen',
              !initialAnimationFinished && 'textInitial'
            )}
          >
            WhatsApp Chat starten
          </span>
        </span>
        <span
          className={cx('logo', vibrateLogo && 'vibrateLogo')}
          onMouseEnter={() => this.setHover('hoverLogo')}
          onMouseLeave={() => this.setNotHover('hoverLogo')}
          {...whatsappTrackingWa('Fixed button')}
        >
          <img
            alt="Logo von WhatsApp"
            src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_whatsapp.svg`}
          />
        </span>
      </a>
    );
  }
}
